import { backupApi } from '../api/backupApi'

export const getBackupLogs = async () => {
  try {
    const response = await backupApi.getLogs()
    return response.data.logs
  } catch (error) {
    console.error(`Error fetching backup logs: `, error)
    throw error
  }
}
